import React from "react";
import LegalPage from "@/pages/LegalPage";

export default function PrivacyPage() {
  return <LegalPage nsKey="privacy" testid="privacy-page" sectionCount={9} />;
}
